import { ShoppingBag } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { useLanguage } from '@/context/LanguageContext';

const FloatingCartButton = () => {
  const { cartCount, setIsCartOpen } = useCart();
  const { language } = useLanguage();
  const isFr = language === 'fr';

  if (cartCount <= 0) return null;

  return (
    <div className="fixed bottom-36 sm:bottom-5 left-1/2 -translate-x-1/2 z-[45] w-[calc(100%-2rem)] max-w-sm sm:w-auto">
      <button
        onClick={() => setIsCartOpen(true)}
        className="w-full sm:w-auto flex items-center justify-center gap-3 bg-black text-white px-7 py-4 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.35)] hover:bg-gray-800 active:scale-[0.98] transition-all border border-white/10"
        style={{ fontFamily: "'Playfair Display', serif" }}
        data-testid="floating-cart-btn"
      >
        <div className="relative">
          <ShoppingBag className="w-5 h-5" />
          <span className="absolute -top-2 -right-2 w-4.5 h-4.5 bg-rose-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center min-w-[18px] min-h-[18px] leading-none">
            {cartCount}
          </span>
        </div>
        <span className="text-sm font-semibold">
          {isFr ? 'Voir panier' : 'View Cart'}
        </span>
        <span className="text-amber-400 font-bold text-sm">&rarr; Book</span>
      </button>
    </div>
  );
};

export default FloatingCartButton;
